export const apiRoute =
  "https://planetview-planet-data.netlify.app/.netlify/functions/api";

export default apiRoute;
